var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("acceptance.rules_exception") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              {
                staticClass:
                  "form-group justify-content-start showLargeScreenOnly",
              },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "1" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.refreshInbox()
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa-light fa-rotate-right" })]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c("div", { staticClass: "requestsList" }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "0" } },
                      [
                        _vm.activateSpinner
                          ? _c("spinner")
                          : _c(
                              "div",
                              { staticStyle: { "overflow-x": "auto" } },
                              [
                                _c("table", { staticClass: "table" }, [
                                  _c("thead", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "6%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.$t("Acceptance")) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "10%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.company_admin_state"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "10%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.establish_admin_state"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "10%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.act_autorization"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "10%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("acceptance.legal_process")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "7%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.vat_nb_validity"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "11%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.is_in_registry"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "9%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.company_stability"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "10%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "acceptance.available_status"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "12%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("acceptance.status")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: { width: "7%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t("acceptance.actions")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm.inboxMessages.length > 0
                                        ? _vm._l(
                                            _vm.inboxMessages,
                                            function (result) {
                                              return _c(
                                                "tr",
                                                { staticClass: "boxRequest" },
                                                [
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.score,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getLabel(
                                                          result.scores
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.comp_state,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "comp_state",
                                                          result.comp_state
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.etab_state,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "etab_state",
                                                          result.etab_state
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.activity,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "activity",
                                                          result.activity
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title:
                                                        result.legal_process,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "legal_process",
                                                          result.legal_process
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.tva,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "tva",
                                                          result.tva
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.inscription,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "inscription",
                                                          result.inscription
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.status,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "status",
                                                          result.status
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("td", {
                                                    staticClass: "text-center",
                                                    attrs: {
                                                      title: result.stability,
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getCodeLabel(
                                                          "stability",
                                                          result.stability
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                      attrs: {
                                                        title:
                                                          _vm.getKYCVerificationsStatus(
                                                            result.final_status
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-row",
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "2",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "icon list-icon",
                                                                class:
                                                                  _vm.getKYCVerificationsIcon(
                                                                    result.final_status
                                                                  ),
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "10",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "-20px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getKYCVerificationsStatus(
                                                                        result.final_status
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "fileClickButton mr-4 cursor",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editException(
                                                                result.id_kyc_validation
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-light fa-pencil",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "fileClickButton",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteException(
                                                                result.id_kyc_validation
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-light fa-trash",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "noResult",
                                                attrs: { colspan: "12" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t("common.no_result")
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "2", offset: "10" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", size: "lg" },
                        on: {
                          click: function ($event) {
                            return _vm.addException()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("acceptance.add")))]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }